module.exports = __webpack_public_path__ + "img/dhl.466b3864.svg";